import { object, string, number } from "yup";

export default object().shape({
    name: string().min(2, "Name must be at least 2 characters").required("Name is required"),
    email: string().email("Invalid email").required("Email is required"),
    password: string().when("$isEditing", {
        is: true,
        then: (schema) => schema.optional(),
        otherwise: (schema) => schema.min(8, "Password must be at least 8 characters").required("Password is required"),
    }),
    maxConcurrentDevices: number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(1, "Must be at least 1")
        .required("Max concurrent devices is required"),
    startDate: string().required("Start date is required"),
    endDate: string()
        .required("End date is required")
        .test("is-after-start", "End date must be after start date", function (value) {
            const { startDate } = this.parent;

            if (!value || !startDate) return true;

            return new Date(value) > new Date(startDate);
        }),
    notes: string(),
    mediaId: number(),
});
